const initMenuMobile = (options) => {
  let navigations = [...document.querySelectorAll('.nav--main-nav')]

  for (let nav of navigations) {
    const buttons = [...nav.querySelectorAll('.nav__link--toggle')]
    buttons.forEach(button => {
      button.addEventListener('click', () => { menuNavigation(button, nav) }, false)
    })
  }

  function menuNavigation(button, nav) {
    if (window.innerWidth < (options?.menuBreakpoint ?? 1200)) {
      const isExpanded = button.getAttribute('aria-expanded') === 'true'

      button.setAttribute('aria-expanded', String(!isExpanded))

      // Close other open menus
      nav.querySelectorAll('.nav__link--toggle').forEach(btn => {
        if (btn !== button) btn.setAttribute('aria-expanded', 'false')
      })
    }
  }


}


export default initMenuMobile